/* eslint tailwindcss/no-custom-classname: off */
// 下矢印記号
export const DownAllow: React.FC = () => {
  return <span className="caret"></span>
}
